<template>
  <div class="mainboxlogin">
    <div class="loginbox_left"><img src="../assets/位图.jpg" /></div>
    <div class="loginbox_right">
      <h1>村兴通管理后台</h1>
      <div class="username">
        <el-input v-model="email" placeholder="手机号或邮箱"></el-input>
      </div>
      <div class="username">
        <el-input
          type="password"
          v-model="password"
          placeholder="输入密码"
        ></el-input>
      </div>
      <el-button @click="handleLogin" type="primary">登录</el-button>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { reactive, toRefs, onMounted } from 'vue'
import { post } from '../utils/request'
import { saveAuth, isLoggedIn } from '../utils/auth'

const route = useRoute()
const router = useRouter()
const data = reactive({ email: '', password: '' })

// 登录成功后回到原来被拦下的页面（来自 ?redirect=/agri/trades 这类查询参数）
const goNext = () => {
  const redirect = typeof route.query.redirect === 'string' ? route.query.redirect : ''
  if (redirect && redirect.startsWith('/') && redirect !== '/') {
    router.replace(redirect)
  } else {
    router.replace({ name: 'dashboard' })
  }
}

const handleLogin = async () => {
  if (!data.email || !data.password) {
    alert('请输入账号和密码！')
    return
  }
  try {
    const result = await post('/api/adminuser/login', {
      email: data.email,
      password: data.password
    })
    if (result?.errno === 0) {
      saveAuth(result.data.token, result.data.user)
      goNext()
    } else {
      alert(result?.errmsg || '账号或密码有误！')
    }
  } catch (e) {
    // 账号或密码错误时后端返回 HTTP 401，axios 会走 catch 分支
    const status = e?.response?.status
    if (status === 401) {
      alert('账号或密码有误！')
    } else if (status === 429) {
      alert('尝试次数过多，请稍后再试！')
    } else {
      alert('数据请求失败，请稍后重试！')
    }
  }
}

const { email, password } = toRefs(data)

// 页面加载时检查本地存储
onMounted(() => {
  const savedUseremail = localStorage.getItem('email')
  const savedPassword = localStorage.getItem('password')
  if (savedUseremail && savedPassword) {
    email.value = savedUseremail
    password.value = savedPassword
  }
  // token 存在且未过期 → 不用再登录
  if (isLoggedIn()) {
    goNext()
  }
})
</script>

<style lang="scss">
@media (min-width: 620px) {
  .mainboxlogin {
    display: flex;
    height: 100%;
    background: #fff;
  }
  .loginbox_left {
    width: 40%;
    height: 100vh;
    overflow: hidden;
  }
  .loginbox_left > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .loginbox_right {
    width: 40%;
    margin: 100px 0 0 50px;
  }
  .loginbox_right > h1 {
    margin-top: 100px;
  }
  .el-input {
    height: 46px;
    margin-bottom: 30px;
  }
  .loginbox_right .el-button {
    height: 46px;
    width: 99%;
    margin-bottom: 30px;
  }
}

/* 手机样式 -------------------------------------------------------------------------------*/
@media (max-width: 620px) {
  .mainboxlogin {
    display: flex;
    height: 100%;
    background: #fff;
  }
  .loginbox_left {
    display: none;
  }
  .loginbox_right {
    width: 86%;
    margin: 100px 0 0 30px;
  }
  .loginbox_right > h1 {
    margin-top: 100px;
  }
  .el-input {
    height: 46px;
    margin-bottom: 30px;
  }
  .loginbox_right .el-button {
    height: 46px;
    width: 99%;
    margin-bottom: 30px;
  }
}
@import "../style/index.scss";
</style>
